import Modal from 'react-modal';

const ModalComponents = ({ open, onRequestClose, children, clickOverlay }) => {
  const customStyles = {
    content: {
      inset: 0,
      width: 'fit-content',
      height: 'fit-content',
      margin: 'auto',
      backgroundColor: 'transparent',
      border: 'none',
      zIndex: '20',
    },
  };

  return (
    <Modal
      isOpen={open}
      onRequestClose={onRequestClose}
      style={customStyles}
      shouldCloseOnOverlayClick={clickOverlay}>
      {children}
    </Modal>
  );
};

export default ModalComponents;
